// src/components/reports/precon-report-builder/precon-dates.ts
import { format, parseISO } from "date-fns";

/**
 * Convert a date-input value (ISO `yyyy-MM-dd`) to the friendly string the
 * renderer expects (`10 Jun 2026`). Anything that isn't parseable ISO — an
 * empty string, or an already-friendly value — passes through unchanged.
 *
 * One source of truth for the cover revision dates and section pre-con dates:
 * `build-precon-payload` applies it before submit, and the read-only preview
 * applies the SAME transform so it shows exactly what the PDF will print
 * (never the raw ISO a `<input type="date">` produces).
 */
export function toFriendlyDate(v: string): string {
  try {
    return format(parseISO(v), "d LLL yyyy");
  } catch {
    return v;
  }
}
